export enum SCCommandFlag {
  SC_CF_ENABLED = 0,
  SC_CF_NOTSUPPORTED = 1,
  SC_CF_DISABLED = 2,
  SC_CF_CHECKED = 4,
  SC_CF_BLINKING = 8,
  SC_CF_NOPARAMSOK = 16,
  SC_CF_STRPARAMSOK = 32
}
